__turbopack_context__.v({
  "active": "Sidebar-module__pflBXq__active",
  "icon": "Sidebar-module__pflBXq__icon",
  "iconContainer": "Sidebar-module__pflBXq__iconContainer",
  "sidebar": "Sidebar-module__pflBXq__sidebar",
});
